import React from 'react';
import type { WidgetInstance } from '../types/contracts';
import TaskCounter       from './TaskCounter';
import UsageChart        from './UsageChart';
import UpcomingReminders from './UpcomingReminders';
import AgentRunsStatus   from './AgentRunsStatus';
import CostCounter       from './CostCounter';

interface Props {
  widget: WidgetInstance;
  data: unknown;
  editing: boolean;
  onRemove: () => void;
}

function WidgetContent({ widget, data }: { widget: WidgetInstance; data: unknown }) {
  switch (widget.type) {
    case 'task_counter':       return <TaskCounter data={data} />;
    case 'usage_chart':        return <UsageChart data={data} />;
    case 'upcoming_reminders': return <UpcomingReminders data={data} />;
    case 'agent_runs_status':  return <AgentRunsStatus data={data} />;
    case 'cost_counter':       return <CostCounter data={data} />;
    default: {
      const unknownSt: React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)' };
      return <div style={unknownSt}>Неизвестный виджет</div>;
    }
  }
}

export default function WidgetCard({ widget, data, editing, onRemove }: Props) {
  const cardSt: React.CSSProperties = {
    width: '100%', height: '100%', borderRadius: 16, overflow: 'hidden',
    display: 'flex', flexDirection: 'column',
    background: 'var(--tg-theme-secondary-bg-color)',
  };
  const handleSt: React.CSSProperties = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '7px 10px 4px',
    background: 'rgba(255,255,255,0.04)',
    cursor: 'grab',
  };
  const gripSt: React.CSSProperties   = { fontSize: 12, opacity: 0.35, color: 'var(--tg-theme-hint-color)' };
  const removeSt: React.CSSProperties = {
    width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center',
    borderRadius: '50%', background: 'rgba(255,69,58,0.25)',
    color: 'var(--tg-theme-destructive-text-color)',
    border: 'none', fontSize: 14, cursor: 'pointer', padding: 0,
  };
  const bodySt: React.CSSProperties = { flex: 1, padding: 12, overflow: 'hidden', minHeight: 0 };
  return (
    <div style={cardSt}>
      {editing && (
        <div className="drag-handle" style={handleSt}>
          <span style={gripSt}>☰</span>
          <button style={removeSt} onClick={onRemove}>×</button>
        </div>
      )}
      <div style={bodySt}>
        <WidgetContent widget={widget} data={data} />
      </div>
    </div>
  );
}
